import { render, staticRenderFns } from "./gender3.vue?vue&type=template&id=527bf416&"
import script from "./gender3.vue?vue&type=script&lang=js&"
export * from "./gender3.vue?vue&type=script&lang=js&"
import style0 from "./gender3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports